export default {
    // 土耳其语
    LOCALE_HTML: {
        'msg.language': 'tr',
        'msg.title': 'Başlık',
        'msg.type': 'Sorun sınıflandırması',
        'msg.des': 'Sorun Açıklaması',
        'msg.phone': 'Cep telefonu numarası',
        'msg.regionCode': 'Alan kodu',
        'msg.email': 'E-posta',
        'msg.choose': 'Mesaj bırakmak için işletmeyi seçin',
        'msg.detail': 'Mesaj Ayrıntıları',
        'msg.back': 'Geri',
        'your.msg': 'Lütfen mesaj bırakın',
        'msg.record': 'Mesaj kaydı',
        'msg.success': 'Mesaj başarılı',
        'to.record': 'Mesaj kaydına git',
        completed: 'tamamlandı',
        submit: 'Gönder Gönder',
        'success.desc':
            'Mesajınız başarıyla iletildi, geri bildiriminiz için teşekkür ederiz',
        'msg.form.input': 'Lütfen giriniz',
        'msg.reply': 'Yanıtla',
        'comment.suc': 'Yorumunuz için teşekkür ederiz! ',
        'comment.fail': 'Gönderim başarısız oldu',
        'comment.placeholder':
            'Hizmetlerimize önerilerde bulunmaktan hoş geldiniz',
        'reply.suc': 'Başarılı gönderim! ',
        'reply.fail': 'Lütfen cevap içeriğinizi giriniz',
        'reply.placeholder': 'Lütfen cevap içeriğinizi giriniz',
        'msg.more': 'Daha fazlasını gör',
        'msg.collapse': 'Daralt',
        'msg.myservice': 'Hizmet değerlendirmem',
        'msg.evaluate': 'Hizmet Değerlendirmesi',
        'msg.evaluateTitle': 'Hizmet Değerlendirmesi',
        'msg.score': 'Puan:',
        'msg.remark': 'Yorum:',
        'msg.status.created': 'Oluşturuldu',
        'msg.status.pending': 'kabul edilecek',
        'msg.status.processing': 'Kabul Ediliyor',
        'msg.status.solved': 'Tamamlandı',
        'msg.service.reply': 'Müşteri Hizmetleri Yanıtı',
        'msg.my.reply': 'Cevabın',
        'msg.toast.des': 'Sorun açıklaması boş',
        'msg.toast.type': 'Soru kategorisi boş',
        'msg.toast.title': 'Başlık boş',
        'msg.toast.none': 'Boş bırakılamaz',
        'msg.toast.noAnnex': 'Lütfen bir ek yükleyin',
        'msg.toast.noEmail': 'E-posta boş olamaz',
        'msg.toast.noTel': 'Telefon numarası boş geçilemez',
        'msg.toast.noRegionCode': 'Alan kodu boş olamaz',
        'msg.toast.noZone': 'Lütfen bir saat dilimi seçin',
        'msg.toast.noDateTime': 'Lütfen tarih ve saati seçin',
        'msg.toast.email': 'Lütfen doğru e-postayı girin',
        'msg.toast.tel': 'Lütfen cep telefonu numaranızı doğru giriniz',
        'msg.toast.regionCode': 'Lütfen alan kodunu seçin',
        'msg.toast.num': 'Lütfen doğru numarayı giriniz',
        'msg.toast.annex': 'Lütfen eki yükleyin',
        'msg.toast.char': 'Lütfen doğru karakteri girin',
        'msg.list.none': 'Henüz veri yok',
        'msg.form.choose': 'Lütfen seçiniz',
        'msg.form.chooseZone': 'Saat dilimini seçin',
        'msg.form.chooseTime': 'Zaman Seç',
        'msg.form.chooseDate': 'Tarih Seç',
        'msg.form.sure': 'Tamam',
        'msg.form.search': 'Ara...',
        'msg.form.uploadError':
            'Yükleme eki biçimi gereksinimleri karşılamıyor',
        'msg.form.uploadXss':
            'Yükleme başarısız oldu, dosya içeriği geçersiz komut dosyası içeriyor',
        'msg.update.time': 'tarihinde güncellendi',
        'msg.replace.images': 'resim',

        MSG016: 'Çözüldü',
        MSG017: 'Çözülmemiş',
        MSG019: 'Gönder',
        MSG072: 'Değerlendirme etiketi boş olamaz! ',
        MSG073: 'Değerlendirme dili boş olamaz! ',
        MSG074: 'Etiket:',
        MSG075: 'Çözüldü mü:',
        MSG076: 'Lütfen sorunun çözülüp çözülmediğini seçin',
        MSG015: 'Bu bilet sorununuzu çözdü mü?',

        'file.size.limit': "Dosya boyutu 50 MB'ı geçemez",
        'detail.file.limit': "Maksimum 15, boyut 50M'yi geçmez",
        'form.question.des.tip': 'Lütfen bir soru açıklaması girin',
        'form.title.tip': 'Lütfen bir başlık giriniz',
        'form.class.tip': 'Lütfen bir soru kategorisi seçiniz',
        'upload.file': 'Eki yükle',
        'file.count.limit': 'En fazla 15 ek yüklenebilir',
        'select.search.placeholder': 'Anahtar kelime ara',
        'msg.form.sizeError1': "Lütfen ekleri 5M'den küçük yükleyin",
        'msg.form.sizeError2': "Lütfen ekleri 50M'den küçük yükleyin",
        'msg.form.submit': 'Gönderiliyor...',
        'msg.form.upload': 'Yükleniyor...',
        'msg.email.tip1': 'Mesajınız bulunamadı',
        'msg.email.tip2':
            'Daha önce mesaj bıraktıysanız e-posta doğrulaması ile kontrol edebilirsiniz',
        'msg.email.tip3': 'E-posta doğrulamasını başlat',
        'msg.email.noData': 'Cari hesapta veri yok',
        'email.verify.tip': 'Mesaj girerken kullanılan e-posta adresi',
        'email.input.placeholder': 'Lütfen e-posta adresinizi giriniz',
        'email.submit': 'E-posta gönder',
        'email.rules.error': 'Lütfen doğru e-postayı girin',
        'email.code.tip':
            'E-posta gönderildi, lütfen aldığınız doğrulama kodunu girin',
        'email.code.placeholder': 'Lütfen doğrulama kodunu giriniz',
        'email.code.submit': 'Şimdi görüntüle',
        'email.notFind.customer': 'Müşteri bilgisi bulunamadı',
        'email.code.wrong': 'Doğrulama kodu hatası, lütfen tekrar girin',
        'email.code.expired':
            'Doğrulama kodunun süresi doldu, lütfen e-postayı yeniden doğrulayın',
        'email.code': 'Doğrulama kodu',
        'email.send.frequently':
            'İşlem çok sık, lütfen daha sonra tekrar deneyin',
        'comment.fail.400133': 'Bu bilet derecelendirildi',
        'not.get.user.info': 'Bilgilerinizi alınamadı',
        'user.verify.tip':
            'Mesaj listesinin içeriğini görmeden önce doğrulamalısınız.',
        'verify.type.email': 'E-posta doğrulaması',
        'verify.text': 'değerlendirme',
        'cancel.text': 'iptal et',
        'get.verify.code': 'Denetim kodu alın',
        'reGet.verify.code': 'Reacquire ',
        'verify.by.email.tip':
            'Denetim kodu içeri girdiğiniz e-posta hesabına e-posta kullanarak gönderilecek',
        'verify.type.phone': 'SMS doğrulaması',
        'phone.placeholder': 'Lütfen telefon numarasını girin.',
        'verify.by.phone.tip':
            'İçeri girdiğiniz telefon numarasına SMS aracılığıyla doğrulama kodu gönderilecek',
        'phone.error': 'Lütfen doğru telefon numarasını girin',
        'phone.errorCode400150': 'Doğrulama kodlarının sık göndermesi',
        'phone.errorCode400233': 'SMS şablonu boş olamaz',
        'phone.errorCode400234': 'Yeterince pazarlama SMS dengesi',
        'phone.errorCode400235': 'Bildirim SMS dengesi yetersiz',
        'phone.errorCode400247': 'İş sırası eklentisi SMS yapılandırma hatası',
        'phone.errorCode4400248': 'SMS şablonu alınamadı',
        'phone.errorCode400249':
            'Bu sayı mevcut bir kullanıcının telefon numarası değil.',
        'phone.errorCode400250': 'Verifik kodu geçti, lütfen tekrar alın.',
        'msg.you.reply': 'Size yanıt verildi',
        'msg.no.reply':'cevap yok',
    },
    LOCALE_REQUEST: {
        400016: 'İş emri bilgisi alma süresi doldu, lütfen yenileyin!'
    },
    LOCALE_SYSTEM: {
        MSG005: ({ name }) =>
            `Merhaba, ${name} müşteri hizmetleri isteğinizi kabul etti`,
        MSG012: (color) =>
            `<span style="color:${color};text-decoration:underline;" class="js-leave-msg">mesaj bırakabilirsiniz</span>`,
        MSG013: 'Müşteri hizmetlerine gönder'
    },
    LOCALE_EDITOR: {
        editor: {
            base: {
                remove: 'silmek',
                cancel: 'İptal etmek',
                confirm: 'Elbette',
                inert: 'sokmak',
                width: 'Genişlik',
                height: 'yüksek'
            },
            controls: {
                clear: 'içeriği temizle',
                undo: 'geri çekmek',
                redo: 'yeniden yapmak',
                fontSize: 'yazı Boyutu',
                lineHeight: 'satır yüksekliği',
                letterSpacing: 'kelime aralığı',
                textIndent: 'paragraf girintisi',
                increaseIndent: 'girintiyi artır',
                decreaseIndent: 'girintiyi azalt',
                border: 'çerçeve',
                color: 'renk',
                textColor: 'metin rengi',
                backgroundColor: 'arka plan rengi',
                tempColors: 'geçici renk',
                bold: 'gözü pek',
                italic: 'italik',
                underline: 'altını çizmek',
                strikeThrough: 'üstü çizili',
                fontFamily: 'yazı tipi',
                textAlign: 'Metin hizalama',
                alignLeft: 'sol',
                alignCenter: 'merkezinde',
                alignRight: 'Sağ',
                alignJustify: 'her iki uç',
                floatLeft: 'sola yüzer',
                floatRight: 'Sağa çık',
                superScript: 'üst simge',
                subScript: 'alt simge',
                removeStyles: 'net stil',
                headings: 'başlık',
                header: 'başlık',
                normal: 'geleneksel',
                orderedList: 'Sıralı Liste',
                unorderedList: 'sırasız liste',
                blockQuote: 'alıntı',
                code: 'kod',
                link: 'Bağlantı',
                unlink: 'bağlantıyı temizle',
                hr: 'yatay çizgi',
                media: 'medya',
                mediaLibirary: 'Medya kütüphanesi',
                emoji: 'Küçük ifade',
                fullscreen: 'Tam ekran',
                exitFullscreen: 'Tam ekrandan çık'
            },
            linkEditor: {
                textInputPlaceHolder: 'bağlantı metnini girin',
                linkInputPlaceHolder: 'Bağlantı adresini girin',
                inputWithEnterPlaceHolder:
                    "Bağlantı adresini girin ve Enter'a basın",
                openInNewWindow: 'Yeni pencerede aç',
                removeLink: 'bağlantıyı kaldır'
            },
            audioPlayer: {
                title: 'ses dosyasını çal'
            },
            videoPlayer: {
                title: 'video dosyasını oynat',
                embedTitle: 'gömülü medya'
            },
            media: {
                image: 'görüntü',
                video: 'video',
                audio: 'ses',
                embed: 'gömülü medya'
            }
        },
        finder: {
            remove: 'silmek',
            cancel: 'İptal etmek',
            confirm: 'onaylamak',
            insert: 'seçili öğeyi ekle',
            width: 'Genişlik',
            height: 'yüksek',
            image: 'resim',
            video: 'video',
            audio: 'ses',
            embed: 'gömülü medya',
            caption: 'Medya kütüphanesi',
            dragTip: 'Dosyayı buraya tıklayın veya sürükleyin',
            dropTip: 'Yüklemek için bırakın',
            selectAll: 'hepsini seç',
            deselect: 'seçimi iptal et',
            removeSelected: 'seçili öğeyi sil',
            externalInputPlaceHolder: 'Kaynak adı|Kaynak adresi',
            externalInputTip: `Kaynak adını ve kaynak adresini ayırmak için "|" kullanın`,
            addLocalFile: 'Yerel kaynaklar ekleyin',
            addExternalSource: 'Web kaynağı ekle',
            unnamedItem: 'isimsiz proje',
            confirmInsert: 'Seçilen öğeyi ekle'
        }
    }
}
